export default {
  NoSend: 0,
  SendWaiting: 1,
  Send: 3,
};
